import { z } from 'zod';

import { INCOTERM_CODES } from '~/constants/incoterms';

import { zodNonNegativeDecimalSchema } from '../validations';

export const zodContractItemSyncEntrySchema = z
  .object({
    buyerArticleId: z.string().max(100).nullish(),
    grossPrice: zodNonNegativeDecimalSchema.nullish(),
    grossPricePerQuantity: z.number().int().min(1).nullish(),
    id: z.uuid().nullish(),
    incoterm: z.enum(INCOTERM_CODES).nullish(),
    isActive: z.boolean().nullish(),
    manufacturer: z.string().max(255).nullish(),
    notes: z.string().nullish(),
    position: z.number().int().min(1).nullish(),
    productDescription: z.string().nullish(),
    productName: z.string().min(1).max(500).nullish(),
    quantityOrdered: zodNonNegativeDecimalSchema.nullish(),
    sellerArticleId: z.string().max(100).nullish(),
    unitType: z.string().nullish(),
  })
  .strict();

export const zodContractItemsSyncPayloadSchema = z
  .object({
    items: z.array(zodContractItemSyncEntrySchema),
  })
  .strict();
